/*
    Calculette capital restant dû

    issue de lpi ancienne génération
*/

  function lpi_init_calcRestantDu() {
		hide("resultBox");
		hide("FormLink");
		show("CalculatorForm");
	}

	function lpi_calcul_calcRestantDu() {
    console.log('lpi_calcul_calcRestantDu()');
		lpi_init_calcRestantDu();

		var emprunt = formatFloat(document.getElementById("emprunt").value, ".") * 1;
		var interet = formatFloat(document.getElementById("interet").value, ".") / 100;
		var duree = document.getElementById("duree").value * 1;
		var mois = document.getElementById("mois").value * 1;
		var annee = document.getElementById("annee").value * 1;

		if(empty(emprunt) || emprunt == 0 || isNaN(emprunt) || mois > 12)
			return false;

		/* Données calculées */
		var taux_periodique = (interet == 0) ? 0 : interet / 12;
		var montant_mensualites = (emprunt == 0) ? 0 : (emprunt * taux_periodique) / (1 - (Math.pow(1 + taux_periodique, - duree * 12)));

		/* date actuelle */
		var current_date = new Date();
		var current_year = current_date.getFullYear();
		var current_month = current_date.getMonth() + 1; /* par defaut : janvier = 0 et decembre = 11 */

		var j = duree * 12;

		/* le calcul a ete recupere sur la calto du tableau d'amortissement */
		for(var i = 0; i <= j; i++){
			/* formatage date */
			var date = new Date(annee, mois - 1 + i, 1);
			var month = date.getMonth() + 1;
			var year = date.getFullYear();
			if((month.toString()).length == 1)
				month = "0" + month;

			if(i == 0){
				var capital = emprunt;
				var principal = 0;
				var interets = 0;
			} else {
				var capital = capitalPrec - principalPrec;
				var interets = capital * taux_periodique;
				var principal = montant_mensualites - interets;
			}

			month = parseInt(month);

			var capitalPrec = capital;
			var principalPrec = principal;

			/* stop le calcul a la date actuelle */
			if (month == current_month && year == current_year)
				break;
		}

		/* Affichage */
		document.getElementById("montant_emprunt").innerHTML = format(emprunt, 2, " ") + " &euro;";
		document.getElementById("montant_mensualites").innerHTML = formatFloat(format(montant_mensualites, 2, " "), ",") + " &euro;";
		document.getElementById("result_duree").innerHTML = duree;
		document.getElementById("montant_capital").innerHTML = formatFloat(format(capital, 2, " "), ",") + " &euro;";


	}
  function lpi_submit_calcRestantDu() {
    lpi_init_calcRestantDu();
    show('FormLink');
    show('resultBox');
		$('.sfi-calc--result__msg').hide();
		$('.sfi-calc--resultat').css('display', 'block');
		jQuery( document.body ).trigger( 'post-load' );
    $('.sfi-calc--result').removeClass('no-result error');
		console.log('Restant dû ok');
		// $('.sfi-calc--resultat').addClass('fadeInDown');

    gtag('event', 'submit', {
      'send_to' : 'UA-122662450-4',
      'event_category' : 'Calculette capital restant du'
    });
    return false;
  }

jQuery(function(){
  lpi_init_calcRestantDu();
})
